import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IWorkerData } from '../../initialState';

export interface IWorkerDeleteRequestAction {
  data: {
    active: boolean;
    id: string;
  };
  functions: {
    error: (err: any) => void;
    handleClose: () => void;
  };
}

function deleteRequest(
  draft: Draft<IWorkerData>,
  _: PayloadAction<IWorkerDeleteRequestAction>,
) {
  draft.delete.config.isLoading = true;
}

export default deleteRequest;
